module.exports = __webpack_public_path__ + "img/mt4-icon8.a751c06.png";